import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import ms from 'ms';

import { type UUID } from '~/types/common';

import { queryKeysInvoiceReprocessing } from '../queryKeys';

import { fetchInvoiceForwardingReasons } from './fetchInvoiceForwardingReasons';
import { type InvoiceForwardingReasonsResponse } from './types';

/**
 * React Query based custom hook for getting the defined list of reasons for forwarding an invoice.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_forward_reasons_invoice_process__process_id__forward_reasons_get
 */
export function useQueryInvoiceForwardingReasons(
  processId: UUID,
  options?: Omit<
    UseQueryOptions<InvoiceForwardingReasonsResponse | undefined>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<InvoiceForwardingReasonsResponse | undefined>({
    enabled: Boolean(processId),
    queryFn: async () => fetchInvoiceForwardingReasons(processId),
    queryKey: queryKeysInvoiceReprocessing.getForwardingReasons(processId),
    staleTime: ms('30s'),
    ...options,
  });
}
